import type { ReactNode } from 'react';

export const symbol_terminal_2: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M530-160q-12.75 0-21.37-8.68-8.63-8.67-8.63-21.5 0-12.82 8.63-21.32 8.62-8.5 21.37-8.5h240q12.75 0 21.38 8.68 8.62 8.67 8.62 21.5 0 12.82-8.62 21.32-8.63 8.5-21.38 8.5H530ZM344-574 182-737q-9-8.8-9-20.9 0-12.1 9-21.1 9-9 21-9t21 9l184 184q9 9 9 21t-9 21L224-369q-9 9-21 9t-21-9.05q-9-9.06-9-21.5 0-12.45 9-21.45l162-162Z"
		/>
	</svg>
);
